"use client";

import { Bold, Code, Italic, Link as LinkIcon, ListTodo } from "lucide-react";

interface EditorToolbarProps {
  onBold: () => void;
  onItalic: () => void;
  onWikiLink: () => void;
  onCode: () => void;
  onCreateTask: () => void;
  taskDisabled?: boolean;
}

/**
 * Barra de formato rápido que aparece junto al título del documento.
 * Sólo se muestra en modo edición. Cada handler inyecta el markdown
 * correspondiente en el textarea via la función pasada por props.
 */
export function EditorToolbar({
  onBold,
  onItalic,
  onWikiLink,
  onCode,
  onCreateTask,
  taskDisabled,
}: EditorToolbarProps) {
  return (
    <div className="flex items-center gap-2">
      <div
        className="flex items-center gap-1 pr-2 border-r border-border/30"
        role="toolbar"
        aria-label="Formato de texto"
      >
        <button
          onClick={onBold}
          className="p-1 hover:bg-secondary rounded text-muted-foreground hover:text-foreground transition-all"
          title="Negrita"
          aria-label="Negrita"
        >
          <Bold className="w-3.5 h-3.5" aria-hidden="true" />
        </button>
        <button
          onClick={onItalic}
          className="p-1 hover:bg-secondary rounded text-muted-foreground hover:text-foreground transition-all"
          title="Cursiva"
          aria-label="Cursiva"
        >
          <Italic className="w-3.5 h-3.5" aria-hidden="true" />
        </button>
        <button
          onClick={onWikiLink}
          className="p-1 hover:bg-secondary rounded text-muted-foreground hover:text-foreground transition-all"
          title="Nota Interna (Wiki-link)"
          aria-label="Insertar wiki-link"
        >
          <LinkIcon className="w-3.5 h-3.5" aria-hidden="true" />
        </button>
        <button
          onClick={onCode}
          className="p-1 hover:bg-secondary rounded text-muted-foreground hover:text-foreground transition-all"
          title="Código"
          aria-label="Código en línea"
        >
          <Code className="w-3.5 h-3.5" aria-hidden="true" />
        </button>
      </div>

      <button
        onClick={onCreateTask}
        disabled={taskDisabled}
        className="p-1 hover:bg-secondary rounded text-muted-foreground hover:text-foreground transition-all disabled:opacity-30"
        title="Crear tarea en este documento"
        aria-label="Crear tarea en este documento"
      >
        <ListTodo className="w-3.5 h-3.5" aria-hidden="true" />
      </button>
    </div>
  );
}
